import { PublicClientApplication } from "@azure/msal-browser";

const MS_CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID;
const REDIRECT_ZIEL_KEY = "ms_redirect_ziel";

export const msalInstance = new PublicClientApplication({
  auth: { clientId: MS_CLIENT_ID, authority: "https://login.microsoftonline.com/common", redirectUri: window.location.origin },
  cache: { cacheLocation: "localStorage" },
});

export const msalBereit = msalInstance.initialize();

// Startet den Redirect-Login. "ziel" ist der Pfad (z.B. "kalender" oder "posteingang"),
// zu dem nach erfolgreicher Anmeldung zurückgesprungen wird.
export async function msLoginRedirect(scopes, ziel) {
  await msalBereit;
  sessionStorage.setItem(REDIRECT_ZIEL_KEY, ziel);
  await msalInstance.loginRedirect({ scopes, prompt: "select_account" });
}

// Muss vor dem ersten Render aufgerufen werden: verarbeitet die Rückkehr vom Microsoft-Login
// und navigiert zurück zur ursprünglichen Seite, nachdem das Konto im jeweiligen localStorage-Key gespeichert wurde.
export async function msRedirectVerarbeiten(accountKeyByZiel) {
  await msalBereit;
  let ergebnis;
  try {
    ergebnis = await msalInstance.handleRedirectPromise();
  } catch (err) {
    console.error("[MSAL] handleRedirectPromise Fehler:", err.message);
    sessionStorage.setItem("ms_redirect_fehler", err.message || String(err));
    return false;
  }
  if (ergebnis) {
    const ziel = sessionStorage.getItem(REDIRECT_ZIEL_KEY);
    sessionStorage.removeItem(REDIRECT_ZIEL_KEY);
    if (ziel && accountKeyByZiel[ziel]) {
      localStorage.setItem(accountKeyByZiel[ziel], ergebnis.account.homeAccountId);
    }
    if (ziel) {
      window.location.replace(`/${ziel}`);
      return true; // Seite wird neu geladen, kein weiteres Rendern nötig
    }
  }
  return false;
}
